import type { FC } from 'react';
import { useNavigationGuard } from '@contexts';
import styles from './Logo.module.css';

const Logo: FC = () => {
    const { guardedNavigate } = useNavigationGuard();

    return (
        <button
            type="button"
            className={styles.logoLink}
            onClick={() => guardedNavigate('/')}
            aria-label="Gå til forsiden"
        >
            <img
                src="/assets/icons/dynamon_logo.svg"
                alt=""
                aria-hidden="true"
            />
        </button>
    );
};

export default Logo;
